// src/components/_v3/touristic-site/PageSkeleton.jsx
import React from 'react';
import styled, {keyframes} from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Enveloppe du contenu réel : fondu d'apparition une fois les données chargées.
export const ContentFadeIn = styled.div`
  animation: ${fadeIn} .35s ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Bone = styled.div`
  background: ${props => props.theme.colors.paperSunk};
  background-image: linear-gradient(
    90deg,
    ${props => props.theme.colors.paperSunk} 0px,
    ${props => props.theme.colors.paperCard} 120px,
    ${props => props.theme.colors.paperSunk} 240px
  );
  background-size: 1200px 100%;
  animation: ${shimmer} 1.4s linear infinite;
  border-radius: 8px;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const SkeletonStyled = styled.div`
  padding-block: 1.6rem 2.2rem;
`;

const PhotoBone = styled(Bone)`
  height: clamp(200px, 32vw, 340px);
  border-radius: ${props => props.theme.radius};
  margin-bottom: 1.2rem;
`;

const GridBones = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
  gap: 1.6rem;
  align-items: start;
  margin-top: 2.2rem;

  @media (max-width: 880px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const PageSkeleton = () => (
  <SkeletonStyled aria-hidden="true" data-testid="poi-v3-skeleton">
    <Bone style={{width: 130, height: 28, borderRadius: 999, marginBottom: '1rem'}} />
    <PhotoBone />
    <Bone style={{width: '55%', height: 38, marginBottom: '.8rem'}} />
    <Bone style={{width: '35%', height: 16, marginBottom: '1.2rem'}} />
    <Bone style={{width: 170, height: 38, borderRadius: 999}} />
    <GridBones>
      <div>
        <Bone style={{height: 14, marginBottom: '.6rem'}} />
        <Bone style={{height: 14, marginBottom: '.6rem'}} />
        <Bone style={{width: '85%', height: 14, marginBottom: '.6rem'}} />
        <Bone style={{width: '60%', height: 14}} />
      </div>
      <Bone style={{height: 140, borderRadius: 20}} />
    </GridBones>
  </SkeletonStyled>
);

export default PageSkeleton;
